var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 16,
    viewBox: "0 0 11 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.4 0C2.4 0 0 2.4 0 5.4C0 6.2 0.3 7.2 0.8 8.3C1.3 9.4 1.9 10.5 2.5 11.5C3.7 13.6 4.9 15.3 4.9 15.3L5.4 16L5.9 15.3C5.9 15.3 7.1 13.6 8.3 11.5C8.9 10.5 9.5 9.3 10 8.3C10.5 7.3 10.8 6.3 10.8 5.4C10.8 2.4 8.3 0 5.4 0ZM5.4 1.2C7.7 1.2 9.6 3.1 9.6 5.4C9.6 5.9 9.3 6.8 8.9 7.8C8.5 8.8 7.9 9.9 7.3 10.9C6.4 12.5 5.8 13.4 5.4 13.9C5.1 13.4 4.5 12.5 3.5 10.9C2.9 9.9 2.3 8.8 1.9 7.8C1.5 6.8 1.2 5.9 1.2 5.4C1.2 3.1 3.1 1.2 5.4 1.2ZM5.4 4.2C4.7 4.2 4.2 4.7 4.2 5.4C4.2 6.1 4.7 6.6 5.4 6.6C6.1 6.6 6.6 6 6.6 5.4C6.6 4.8 6 4.2 5.4 4.2Z",
    fill: "#666666"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.3ed3e2339589b62b72bac98354a6e144.svg";
export { ForwardRef as ReactComponent };